import React, { useMemo } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Collapse,
  Space,
  Button,
  Tag
} from '@lockerpm/design';

import {
  EditOutlined,
  DeleteOutlined
} from "@ant-design/icons";

import itemsComponents from "../../../../../components/items";
import commonComponents from "../../../../../components/common";

import {
  convertDateTime,
  projectMemberRole,
  getEnvironment
} from '../../../../../secrets-web/src/utils/common'

const BoxData = (props) => {
  const { TextCopy } = itemsComponents;
  const { OnboardingTooltip } = commonComponents;
  const { t } = useTranslation();
  const {
    loading = false,
    className = '',
    data = [],
    params = {},
    environments = [],
    onUpdate = () => {},
    onDelete = () => {}
  } = props;

  const userInfo = useSelector((state) => state.auth.userInfo);

  const boxData = useMemo(() => {
    return data.map((d, index) => ({ ...d, stt: index + 1 + (params.page - 1) * params.size }))
  }, [data])

  return (
    <Collapse
      className={className}
      bordered={true}
      expandIconPosition="end"
      size="small"
      collapsible='icon'
      loading={loading}
    >
      {
        boxData.map((record) => <Collapse.Panel
          key={record.id}
          header={<div
            className="flex align-items justify-between"
          >
            <div className="flex align-items">
              <TextCopy
                value={record.organization_member?.email || record.organization_member?.user?.email}
              />
            </div>
            {
              (record.organization_member?.email || record.organization_member?.user?.email) !== userInfo?.username && <Space size={[8, 8]}>
                <Button
                  icon={<EditOutlined />}
                  type={'link'}
                  size="small"
                  onClick={() => onUpdate(record)}
                />
                <Button
                  icon={<DeleteOutlined />}
                  type={'link'}
                  size="small"
                  danger
                  onClick={() => onDelete(record)}
                />
              </Space>
            }
          </div>}
        >
          <div className="flex items-center mb-2">
            <p className="font-semibold mr-2">{t('common.role')}:</p>
            <Tag
              color={projectMemberRole(record.role)?.color}
            >
              <TextCopy
                value={t(projectMemberRole(record.role)?.label)}
              />
            </Tag>
          </div>
          <div className="flex">
            <p className="font-semibold mr-2">{t('member.access_environment')}:</p>
            {
              (() => {
                const envs = [{}, ...(record.access_environments || [])].map((env) => getEnvironment(env.environment_id, environments))
                return <Space size={[0, 8]} wrap className="w-2/3">
                  {
                    envs.map((env, index) => <OnboardingTooltip
                      title={env?.key ? t('onboarding.env_all_default') : ''}
                      placement="top"
                      key={index}
                      content={
                        <Tag
                          color={env.color}
                        >
                          <TextCopy
                            value={env?.name}
                          />
                        </Tag>
                      }
                    />)
                  }
                </Space>
              })()
            }
          </div>
          <div className="flex items-center">
            <p className="font-semibold mr-2">{t('common.access_date')}:</p>
            <TextCopy
              value={convertDateTime(record.access_date)}
            />
          </div>
        </Collapse.Panel>)
      }
    </Collapse>
  );
}

export default BoxData;
